import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux'
import { push } from 'react-router-redux'
import { SubmissionError, FieldArray } from 'redux-form'
import LoadingProgress from '../components/LoadingProgress'
import Box from '../components/Box'
import ErrorMessage from '../components/ErrorMessage'
import { fetchWithdrawal, updateWithdrawal } from '../actions/withdrawals'
import { renderInputField, renderTextAreaField, renderSelectField } from '../utils/forms'

import "../styles/WithdrawalsAdminView.css"

class WithdrawalEditBalanceForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = { loaded: false }
    this.submit = this.submit.bind(this)
  }

  componentDidMount() {
    const { withdrawals, fetchWithdrawal, match } = this.props

    fetchWithdrawal(match.params.id)
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.loaded && nextProps.withdrawals.withdrawal) {
      this.setState({ loaded: true })
    }
  }

  submit(props) {
    const { updateWithdrawal, withdrawals } = this.props

    return updateWithdrawal(withdrawals.withdrawal._id, props)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          })
        }

        return response
      })
  }

  render() {
    const { withdrawal, withdrawals, error, pristine, submitting, handleSubmit } = this.props

    if (!this.state.loaded) {
      if (withdrawals.error) {
        return (
          <ErrorMessage message={withdrawals.error.message} />
        )
      }

      return (
        <LoadingProgress />
      )
    }

    return (
      <div className="withdrawals-admin-view">
        {/* Header */}
        <div className="withdrawals-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-balance-scale mr-3"></i>
                <span className="text-vw-dark mr-1">Cuadrar</span>
                <span className="text-vw-light">Retiro</span>
              </h1>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit(this.submit)}>
          {(withdrawals.withdrawal.Type == 0 || withdrawals.withdrawal.Type == 2 || withdrawals.withdrawal.Type == 3) ?
            (
              <div className="withdrawals-admin-filter-card">
                <div className="withdrawals-admin-filter-header">
                  <h3>
                    <i className="fas fa-coins"></i>
                    <span>Recuento de Monedas</span>
                  </h3>
                </div>
                <div className="withdrawals-admin-filter-body">
                  <table className="table table-hover table-clickable">
                    <thead className="thead-dark">
                      <tr>
                        <th scope="col">Moneda</th>
                        <th scope="col">Ticket (unidades)</th>
                        <th scope="col">Recuento (unidades)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>0.50 €</td>
                        <td>
                          {withdrawals.withdrawal.Units050CoinCash}
                        </td>
                        <td>
                          <Field name="Units050CoinCashReal"
                            component={renderInputField}
                            type="text"
                            label="" />
                        </td>
                      </tr>
                      <tr>
                        <td>1 €</td>
                        <td>
                          {withdrawals.withdrawal.Units100CoinCash}
                        </td>
                        <td>
                          <Field name="Units100CoinCashReal"
                            component={renderInputField}
                            type="text"
                            label="" />
                        </td>
                      </tr>
                      <tr>
                        <td>2 €</td>
                        <td>
                          {withdrawals.withdrawal.Units200CoinCash}
                        </td>
                        <td>
                          <Field name="Units200CoinCashReal"
                            component={renderInputField}
                            type="text"
                            label="" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="withdrawals-admin-filter-card">
                <div className="withdrawals-admin-filter-header">
                  <h3>
                    <i className="fas fa-money-bill-wave"></i>
                    <span>Recuento de Billetes</span>
                  </h3>
                </div>
                <div className="withdrawals-admin-filter-body">
                  <table className="table table-hover table-clickable">
                    <thead className="thead-dark">
                      <tr>
                        <th scope="col">Billete</th>
                        <th scope="col">Ticket (unidades)</th>
                        <th scope="col">Recuento (unidades)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>5 €</td>
                        <td>
                          {withdrawals.withdrawal.Units5BillCash}
                        </td>
                        <td>
                          <Field name="Units5BillCashReal"
                            component={renderInputField}
                            type="text"
                            label="" />
                        </td>
                      </tr>
                      <tr>
                        <td>10 €</td>
                        <td>
                          {withdrawals.withdrawal.Units10BillCash}
                        </td>
                        <td>
                          <Field name="Units10BillCashReal"
                            component={renderInputField}
                            type="text"
                            label="" />
                        </td>
                      </tr>
                      <tr>
                        <td>20 €</td>
                        <td>
                          {withdrawals.withdrawal.Units20BillCash}
                        </td>
                        <td>
                          <Field name="Units20BillCashReal"
                            component={renderInputField}
                            type="text"
                            label="" />
                        </td>
                      </tr>
                      <tr>
                        <td>50 €</td>
                        <td>
                          {withdrawals.withdrawal.Units50BillCash}
                        </td>
                        <td>
                          <Field name="Units50BillCashReal"
                            component={renderInputField}
                            type="text"
                            label="" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )
          }

          {error && <div className="alert alert-danger">{error}</div>}
          <div className="withdrawals-admin-filter-body">
            <button className="withdrawals-admin-btn primary mr-2" type="submit"
              disabled={pristine || submitting}>
              <i className="fas fa-save"></i>
              <span>Cuadrar</span>
            </button>
          </div>
        </form>
      </div>
    )
  }
}

WithdrawalEditBalanceForm = reduxForm({
  form: 'WithdrawalEditBalanceForm',
  enableReinitialize: true,
  onSubmitSuccess: (result, dispatch, props) => {
    props.push(`/withdrawals`)
  }
})(WithdrawalEditBalanceForm)

const mapStateToProps = state => ({
  withdrawals: state.withdrawals,
  initialValues: state.withdrawals.withdrawal
})

const mapDispatchToProps = dispatch => ({
  fetchWithdrawal: bindActionCreators(fetchWithdrawal, dispatch),
  updateWithdrawal: bindActionCreators(updateWithdrawal, dispatch),
  push: bindActionCreators(push, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(WithdrawalEditBalanceForm)


